import { useEffect, useState } from 'react';
import { getPhotoGroups } from '../../../api/reports.api';
import moment from 'moment-jalaali';

export default function PhotosTab({ userId }) {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPhotos();
  }, []);

  const loadPhotos = async () => {
    try {
      console.log('Loading photo groups for user:', userId);

      const res = await getPhotoGroups(userId);
      console.log('Fetched groups:', res.data);

      const groups = res.data?.groups || [];

      const finalList = [];

      groups.forEach((g) => {
        g.photos?.forEach((url) => {
          finalList.push({
            url,
            date: g.createdAt,
          });
        });
      });

      // جدیدترین عکس‌ها اول
      finalList.sort((a, b) => new Date(b.date) - new Date(a.date));

      setPhotos(finalList);
    } catch (err) {
      console.error('Error loading photo groups', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p>در حال بارگذاری...</p>;
  if (photos.length === 0) return <p>عکسی موجود نیست.</p>;

  function PhotoGrid({ photos }) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        {photos.map((src, i) => (
          <ZoomableImage key={i} src={src} />
        ))}
      </div>
    );
  }

  function ZoomableImage({ src }) {
    const [isHover, setIsHover] = useState(false);
    const [origin, setOrigin] = useState('center center');

    const handleMove = (e) => {
      const rect = e.currentTarget.getBoundingClientRect();

      // درصد مکان موس نسبت به عکس
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      setOrigin(`${x}% ${y}%`);
    };

    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {photos.map((p, i) => (
          <div key={i} className="bg-white rounded-xl shadow border p-2">
            {/* عکس با افکت ذره‌بین */}
            <ZoomableImage src={p.url} />

            <p className="text-xs text-gray-500 mt-2 text-center">
              {moment(p.date).format('jYYYY/jMM/jDD')}
            </p>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div>
      <h3 className="text-lg font-bold mb-4">آلبوم تصاویر</h3>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {photos.map((p, i) => (
          <div key={i} className="bg-white rounded-xl shadow border p-2">
            <img
              src={p.url}
              className="rounded-lg object-cover w-full h-48"
              alt=""
            />

            <p className="text-xs text-gray-500 mt-2 text-center">
              {moment(p.date).format('jYYYY/jMM/jDD')}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
